import { asCalendarDate } from '@omnea-app/packages/universal/date-utils/asCalendarDate'
import { type FilterOperator, isRangeOperator } from './filterOperators'
import { numericFilterOperands } from './numericFilter'

export const DEFAULT_DATE_FILTER_OPERATOR: FilterOperator = 'between'

export type DateFilterOperands = { low: string; high: string }

/**
 * The days a date filter compares against, or null while any is missing or not a real `yyyy-MM-dd`
 * day. A range's bounds come back ordered, so the order they were picked in never matters.
 */
export const dateFilterOperands = (operator: FilterOperator, values: string[] | null): DateFilterOperands | null => {
  if (values == null || values.length !== (isRangeOperator(operator) ? 2 : 1)) return null
  if (!values.every((value) => asCalendarDate(value) != null)) return null
  // yyyy-MM-dd sorts chronologically as text.
  const [low = '', high = low] = values.toSorted()
  return { low, high }
}

/** Whether a compared filter's values parse as the operator needs — numbers or days, never a mix. */
export const hasComparableOperands = (operator: FilterOperator, values: string[] | null): boolean =>
  numericFilterOperands(operator, values) != null || dateFilterOperands(operator, values) != null
